import { useState, useEffect, useCallback } from "react";
import axios from "axios";

export const DEFAULT_HOME_HERO = {
  headline: "The future of lawn care",
  subheadline:
    "Custom quotes from your properties — add multiple lots, one-time or monthly subscription.",
  imageUrl: "",
};

export const DEFAULT_BRANDING = {
  primaryColor: "#2d6a4f",
  accentColor: "#4caf50",
  showServiceCarousel: true,
  footerAttribution: "",
  logoUrl: "",
  hasStoredLogo: false,
};

/**
 * Hosted quote page: hero copy + branding (colors, carousel visibility, footer line).
 * GET /site-settings/public
 */
export function usePublicSiteSettings() {
  const [homeHero, setHomeHero] = useState(DEFAULT_HOME_HERO);
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get("/site-settings/public");
      const h = data.homeHero;
      if (h && typeof h === "object") {
        setHomeHero({
          headline: typeof h.headline === "string" && h.headline ? h.headline : DEFAULT_HOME_HERO.headline,
          subheadline: typeof h.subheadline === "string" ? h.subheadline : DEFAULT_HOME_HERO.subheadline,
          imageUrl: typeof h.imageUrl === "string" ? h.imageUrl : "",
        });
      } else {
        setHomeHero(DEFAULT_HOME_HERO);
      }
      const b = data.branding;
      if (b && typeof b === "object") {
        setBranding({
          primaryColor: typeof b.primaryColor === "string" ? b.primaryColor : DEFAULT_BRANDING.primaryColor,
          accentColor: typeof b.accentColor === "string" ? b.accentColor : DEFAULT_BRANDING.accentColor,
          showServiceCarousel: b.showServiceCarousel !== false,
          footerAttribution: typeof b.footerAttribution === "string" ? b.footerAttribution : "",
          logoUrl: typeof b.logoUrl === "string" ? b.logoUrl : "",
          hasStoredLogo: b.hasStoredLogo === true,
        });
      } else {
        setBranding(DEFAULT_BRANDING);
      }
    } catch {
      setHomeHero(DEFAULT_HOME_HERO);
      setBranding(DEFAULT_BRANDING);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { homeHero, branding, loading, refetch };
}
